<div class="area-list-filter" #filterBlock>

    <div class="area-list-filter__searching" [ngClass]="{'input-has-focus' : inputHasFocus}">
        <div class="area-list-filter__search-input">
            <tk-search [control]="form.controls['Phrase']" [loading]="loading"
                [themeType]="viewMode === ViewMode.Form ? searchThemeEnum.Dark : searchThemeEnum.Normal"
                (onEnterEvent)="onSearchEnter()" (onClearEvent)="onClearEnter()" (onFocusEvent)="onInputFocus($event)">
            </tk-search>
        </div>
    </div>

    <div *ngIf="viewMode === ViewMode.List" class="area-list-filter__tagging">
        <tk-tag-picker [tagType]="2" (onSelectedTags)="handleOnSelectedTags($event)"
            (onHeightChanged)="handleOnHeightChanged($event)"></tk-tag-picker>
    </div>

</div>